import { ApolloClient, InMemoryCache, split, from } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { authLink, httpLink } from 'services/apollo/links/authLink';
import { wsLink } from 'services/apollo/links/wsLink';
import { errorLink } from 'services/apollo/links/errorLink';

// Re-export Logout so existing callers (e.g. MoreDrawer) keep working
// without changing their import path.
export { Logout } from 'services/apollo/links/errorLink';

// Route subscription operations to wsLink; everything else through authLink + httpLink.
const splitLink = split(
    ({ query }) => {
        const def = getMainDefinition(query);
        return def.kind === 'OperationDefinition' && def.operation === 'subscription';
    },
    wsLink,
    authLink.concat(httpLink)
);

const client = new ApolloClient({
    link: from([errorLink, splitLink]),
    cache: new InMemoryCache(),
});

export default client;
